import React from 'react'
import useGetLessonLogs from '../../../../Model/useLessonLogs/index'

const LessonLogs = ({ lessonId }) => {
  const { logs, loading, error } = useGetLessonLogs(lessonId)

  if (loading) return <div>Loading logs...</div>
  if (error) return <div className='text-error'>Error loading logs</div>

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A'
    const date = new Date(dateString)
    return date.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }) + ' at ' + date.toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
  }

  const formatDatesInDescription = (description) => {
    if (!description) return 'No description available'

    // Common date patterns to match
    const datePatterns = [
      // Specific format: 7/24/2025, 8:00:00 PM
      /\b\d{1,2}\/\d{1,2}\/\d{4},\s+\d{1,2}:\d{2}:\d{2}\s+(?:AM|PM)\b/g,
      // ISO format: 2024-01-15T10:30:00Z or 2024-01-15T10:30:00.000Z
      /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?(?:Z|[+-]\d{2}:\d{2})?\b/g,
      // Standard format: 2024-01-15 or 01/15/2024 or 01-15-2024
      /\b\d{4}-\d{2}-\d{2}\b/g,
      /\b\d{1,2}\/\d{1,2}\/\d{4}\b/g,
      /\b\d{1,2}-\d{1,2}-\d{4}\b/g,
      // Long format: January 15, 2024
      /\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2},?\s+\d{4}\b/g
    ]

    let formattedDescription = description

    datePatterns.forEach(pattern => {
      formattedDescription = formattedDescription.replace(pattern, (match) => {
        let parsedDate

        // Handle the specific format that should be treated as UTC
        if (/\b\d{1,2}\/\d{1,2}\/\d{4},\s+\d{1,2}:\d{2}:\d{2}\s+(?:AM|PM)\b/.test(match)) {
          // Parse as UTC by converting to ISO format first
          const tempDate = new Date(match)
          if (!isNaN(tempDate.getTime())) {
            // Get UTC components and create new date as if it were UTC
            const utcDate = new Date(Date.UTC(
              tempDate.getFullYear(),
              tempDate.getMonth(),
              tempDate.getDate(),
              tempDate.getHours(),
              tempDate.getMinutes(),
              tempDate.getSeconds()
            ))
            parsedDate = utcDate
          }
        } else {
          // Handle other formats normally
          parsedDate = new Date(match)
        }

        // Check if the date is valid and format it
        if (parsedDate && !isNaN(parsedDate.getTime())) {
          return formatDate(parsedDate.toISOString())
        }
        return match // Return original if parsing fails
      })
    })

    return formattedDescription
  }

  // Sort logs by date in descending order (newest first)
  const sortedLogs = [...logs].sort((a, b) => {
    const dateA = new Date(a.date)
    const dateB = new Date(b.date)
    return dateB - dateA
  })

  return (
    <div>
      {logs.length === 0 ? (
        <div className='w-100 d-flex flex-row justify-content-center py-3'>
          <span className='text-dark font-weight-light'>No logs available for this lesson.</span>
        </div>
      ) : (
        <div className='mt-2' style={{ height: 'auto', overflowY: 'auto' }}>
          {sortedLogs.map(log => (
            <div
              key={log.id}
              className='py-3 mb-2'
              style={{ /* backgroundColor: '#F0F4F8', borderRadius: '12px', */ padding: '12px' }}
            >
              <div className='font-weight-bold mb-1' style={{ color: '#778699' }}>
                {formatDatesInDescription(log.description)}
              </div>
              <div className='font-weight-light' style={{ color: '#778699' }}>
                {formatDate(log.date)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default LessonLogs
